<woo-modal-layout size="medium" (close)="close()">
    <h3 header>Support</h3>

    @if(!feedbackSent()) {
      <h4 class="thin">
        Behöver du hjälp med din bokning? Ring <a href="tel:{{supportPhone()}}" class="text-info">{{supportPhone()}}</a>
      </h4>
      <h4 class="thin">För mer info, besök <a [routerLink]="['/help']" class="text-info">hjälpsidan</a>.</h4>

      <h4 class="thin">
          Har du tekniska problem, fyll i formuläret nedan.
      </h4>
    }
    @if(!feedbackSent()) {
      <div class="inner-block">
        <form #feedbackForm="ngForm" (ngSubmit)="sendFeedback(feedback())">
            @if(!isLoggedIn()) {
                <div class="input__container">
                    <label for="name">Vad heter du?</label>
                    <input id="name" name="name"  type="text" [required]="!isLoggedIn()" [(ngModel)]="name">
                </div>
                <div class="input__container">
                    <label for="email">Hur kan vi kontakta dig?</label>
                    <input id="email" name="email"  type="text" [required]="!isLoggedIn()" [(ngModel)]="email">
                </div>
            }
            <div class="input__container">
              <label for="desc">Beskriv problemet med en mening</label>
              <input id="desc" name="desc"  type="text" required [(ngModel)]="problemDescription">
            </div>
            <div class="input__container">
              <label for="where">Var uppstår problemet?</label>
              <input id="where" name="where"  type="text" required [(ngModel)]="problemArea">
            </div>
            <div class="input__container">
              <label for="exp">Vad förväntas hända?</label>
              <textarea id="exp" name="exp"  required [(ngModel)]="expectedOutcome" row="3"></textarea>
            </div>
            <div class="input__container">
              <label for="got">Vad händer istället?</label>
              <textarea id="got" name="got"  required [(ngModel)]="actualOutcome" row="3"></textarea>
            </div>
            <button class="button primary-1" type="submit" [disabled]="!feedbackForm.valid">Skicka</button>
        </form>
      </div>
    } @else {
      <div class="text-center">
        <div class="inner-block">
          <h3 class="thin">
            <span class="icon-ok text-info"></span><br>
            Tack för att du hjälper oss göra WOO ännu bättre!
          </h3>
        </div>
        <button footer class="button primary-1" type="submit" (click)="close()">Stäng</button>
      </div>
    }   
  </woo-modal-layout>
  